import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container, SectionLabel } from '../../design';
import { MKT } from './links';
import './trust.css';
// Why you can hand this the car: four true specifics, on the home page and both audience pages.
// Each line is checked against the app (Help → Customs, Settings, Outbox; the Security page).
const ITEMS = [
    {
        k: '代理',
        title: 'Your own exporter accounts',
        text: 'Searches and bids go through the accounts you open with Japan Car Direct, JDM Auc or Pacific Coast JDM. Right Hand DMS isn’t an exporter, so it never buys cars or holds your deposit.'
    },
    {
        k: '下書',
        title: 'Nothing goes out unseen',
        text: 'The app writes the emails to your exporter, your broker and your customers, and shows you each one before it goes out from your own mailbox. Automatic sheet requests run only on hunts where you’ve switched them on.'
    },
    {
        k: '通関',
        title: 'A licensed broker, built in',
        text: 'Kappa Customs Brokers, a licensed customs broker, is built in at a flat fee per vehicle that covers the ISF, the entry and the EPA/DOT forms. You can use your own broker instead.'
    },
    {
        k: '分離',
        title: 'Your data stays in your shop',
        text: 'Each shop’s cars, documents and customers are walled off from every other shop. Exporter logins and mailbox tokens are encrypted at rest, and we use them for your work and nothing else.'
    }
];
export function TrustGrid({ title = 'Built so you stay in charge.' }) {
    return /*#__PURE__*/ _jsx("section", {
        className: "mk-trust mk-ground--shu",
        children: /*#__PURE__*/ _jsxs(Container, {
            children: [
                /*#__PURE__*/ _jsx(SectionLabel, {
                    k: "安心",
                    className: "mk-trust__label",
                    children: "Why it’s safe to hand it the car"
                }),
                /*#__PURE__*/ _jsx("h2", {
                    className: "mk-trust__title",
                    children: title
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "mk-trust__grid",
                    children: ITEMS.map((it)=>/*#__PURE__*/ _jsxs("div", {
                            className: "mk-trust__item",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "mk-trust__k",
                                    "aria-hidden": "true",
                                    children: it.k
                                }),
                                /*#__PURE__*/ _jsx("h3", {
                                    className: "mk-trust__name",
                                    children: it.title
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "mk-trust__text",
                                    children: it.text
                                })
                            ]
                        }, it.k))
                }),
                /*#__PURE__*/ _jsx("a", {
                    href: MKT.security,
                    className: "mk-trust__more",
                    children: "Security & privacy →"
                })
            ]
        })
    });
}
